import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { SharedFileContractService } from "../interfaces/shared-file-contract.service";

@Injectable({
  providedIn: "root"
})
export class SharedFileOfflineService implements SharedFileContractService {
  constructor() {}
  sharedFileSasKey(dataId: string, dataType: string, startDate: string, exipiryDate: string, SharedUserEmailAddress: string[]): Observable<string> {
    throw new Error("Method not implemented.");
  }
}
